import { createAction, props } from '@ngrx/store';

export const changeMarket = createAction(
  '[Market] Changed Market',
  props<{ market: string }>()
);
